import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
import { UserProfilePasswordReset } from '../../models/user-profile-password-reset'
import { UserProfile } from '../../models/user-profile'
import { CurrentUser } from '../../../common/models/current-user'
import { UserProfileGateway } from '../../gateways/user-profile-gateway'
import { Router, ActivatedRoute } from '@angular/router'
import { SecurityQuestion } from '../../models/security-question-model'
import { Location } from '@angular/common'
import { UserDataService } from '../../gateways/user-data-service'
import { FormValidationService } from '../../../validations/form-validation-service'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { PasswordCorrectValidator } from '../../../validations/password-correct-validator'
import { UpdatePasswordComponent } from '../../components/update-password/update-password.component'
import { PhoneNumberInputMask } from '../../../common/input-masks/phone-number.input-mask'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'Change_Cellphoneno',
    templateUrl: 'update-cellphoneno.component.html'
})

export class UpdateCellphonenoComponent implements OnInit {

    phoneNumberInputMask = new PhoneNumberInputMask()
    oldPasswordErrorMsg: string
    errorConfMsg: string
    userProfileID: number
    userProfileName: string
    userCellPhoneNo: string
    userConfirmCellPhoneNo: string
    CloseBtnText: string
    userProfileModel: UserProfile
    type: string = 'password'
    ErrorMessages: any[]
    errorlist: any[]
    errorlists: any[]
    isFormValid: boolean
    showSuccessMsg: boolean
    insCo: string
    questionOptions: ValidatedSelectOptionModel[] = []
    notBlankValidator = new NotBlankGenericFieldValidator()
    passwordCorrectValidator: PasswordCorrectValidator
    updatePasswordComponent: UpdatePasswordComponent
    numericValidator = new NumericTextFieldValidator()
    lengthValidator = new LengthTextFieldValidator(10)

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef;

    constructor(private routers: Router, private route: ActivatedRoute, private _networkUserAccessGateway: UserAccessGateway, private portalglobals: PortalGlobals,
        private userProfileGateway: UserProfileGateway, private _location: Location,
        private formValidationService: FormValidationService,
        private userdataservice: UserDataService) {
        this.userProfileModel = {} as UserProfile
        this.route.params.subscribe(params => {
            if (params['userprofileid']) {
                this.userProfileID = params['userprofileid']
                this.passwordCorrectValidator = new PasswordCorrectValidator(this.userProfileGateway, this.userProfileID)
            }
            if (params['insCo']) {
                this.insCo = params['insCo']
            }
        })
        // this.updatePasswordComponent = new UpdatePasswordComponent();
    }
    ngOnInit() {
        this.showSuccessMsg = false
        this.isFormValid = true
        this.userProfileGateway.findUserProfileByProfileID(this.userProfileID).subscribe(
            (model: UserProfile) => {
                if (model !== undefined && model !== null) {
                    this.userProfileModel = model
                    this.userProfileName = model.UserProfileName
                }
            })

    }


    private validateForm() {
        this.ErrorMessages = []
        this.isFormValid = true
       // if (this.userCellPhoneNo === '') {
        if (this.userCellPhoneNo === undefined || this.userCellPhoneNo === null || this.userCellPhoneNo === '') {
            this.isFormValid = false
            this.ErrorMessages.push('Please enter Cell Phone Number')
        }
      //  if (this.userConfirmCellPhoneNo === '') {
        if (this.userConfirmCellPhoneNo === undefined || this.userConfirmCellPhoneNo === null || this.userConfirmCellPhoneNo === '') {
            this.isFormValid = false
            this.ErrorMessages.push('Please enter Confirm Cell Phone Number')
        }
        
        if (/^\d{10}$/.test(this.userCellPhoneNo)) {

        } else {
            if (!this.isValidNumber(this.userCellPhoneNo)) {
               //  this.ErrorMessages.push('Cell Phone cannot contain letters or special characters.')
                this.isFormValid = false

            }
            else {
               //  this.ErrorMessages.push('Cell Phone must be exactly 10 numbers.')
                this.isFormValid = false
            }
        }

        if (!(this.userConfirmCellPhoneNo === this.userCellPhoneNo)) {
            this.isFormValid = false
            this.ErrorMessages.push('Both CellPhoneNo and ConfirmCellPhoneNo should match')
        }
    }
    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }

    Save() {
        this.validateForm()
        if (this.isFormValid === true) {

            this.userProfileGateway.updateCellphoneNo(this.userCellPhoneNo, this.userProfileID).subscribe(
                (model: Boolean) => {
                    if (model.valueOf() === true) {
                        this.isFormValid = true
                        this.showSuccessMsg = true
                        this.errorConfMsg = 'You have successfully changed the email.'
                        this.redirectnextPage()
                    } else {
                        this.errorConfMsg = 'Something went wrong, please try again.'
                    }
                    this.focusableEleTop.nativeElement.focus()
                },
                (error) => {
                    this.errorlist = JSON.parse(error.statusText)
                    this.errorlists = this.errorlist.toString().split(',')
                    this.ErrorMessages = this.errorlists
                    this.isFormValid = false
                    this.focusableEleTop.nativeElement.focus()
                }
            )

        }
        else {
            this.focusableEleTop.nativeElement.focus()
        }

    }


    private redirectnextPage() {
        this._networkUserAccessGateway.getCurrentUser()
            .subscribe(user => {
                if (user != null)
                {
                    
                    if (localStorage.getItem('showlicense') === null || localStorage.getItem('showlicense') === 'null') {

                        let url = '/' + user.insuranceCompanyShortName.toLowerCase() +  '/user-management/licenselogin/' + user.userProfileId
                        this.routers.navigateByUrl(url)
                    }
                    else {
                        this.routers.navigate(['/' + user.insuranceCompanyShortName.toLowerCase() + '/home'])
                    }

                } else {
                    this.goToLogin()
                }
            },
            error => {

                this.goToLogin()
            })
    }
    goToLogin() {
        window.location.href = '/Auth/Login.aspx?insCo=' + this.insCo
    }
}
